import { render } from "./PageSubscription.vue?vue&type=template&id=80ce0a2c"
import script from "./PageSubscription.vue?vue&type=script&lang=js"
export * from "./PageSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__